<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header font-m">
                <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <h3 class="text-center">{{$t('purchase_exchange_preview')}}</h3>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <table class="table-print">
                        <tbody>
                        <tr>
                            <td style="width: 100px;">{{ $t('branch_name') }}</td>
                            <td style="width: 15px;">:</td>
                            <td>{{exchange.BranchName}}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('receiver') }}</td>
                            <td>:</td>
                            <td>{{employee.KhmerName}}</td>
                        </tr>
                        <tr>
                            <td>{{$t('vendor')}}</td>
                            <td>:</td>
                            <td>{{exchange.VendorName}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-6">
                    <table class="table-print" align="right">
                        <tbody>
                        <tr>
                            <td style="width: 100px;">{{ $t('invoice_no') }}</td>
                            <td style="width: 15px;">:</td>
                            <td style="min-width: 150px;">{{exchange.InvoiceNo}}</td>
                        </tr>
                        <tr>
                            <td>{{$t('date')}}</td>
                            <td>:</td>
                            <td>{{$format(dateExchange, 'DD/MM/YYYY')}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                        <tr>
                            <th>{{$t('no')}}</th>
                            <th>{{$t('item_name')}}</th>
                            <th>{{$t('uom')}}</th>
                            <th>{{$t('qty')}}</th>
                            <th>{{$t('cost')}}</th>
                            <th>{{$t('discount')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in lines" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{ret.ItemName}}</td>
                            <td>{{ret.UomName}}</td>
                            <td>{{ret.Quantity}}</td>
                            <td>{{ret.Cost}}</td>
                            <td>{{ret.Discount}}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <th colspan="5" class="text-right">សរុបទាំងអស់:</th>
                            <th class="text-right">
                                {{exchange.TotalAmount}}
                            </th>
                        </tr>
                        <tr>
                            <th colspan="5" class="text-right">ចុះថ្លៃ:</th>
                            <th class="text-right">
                                {{exchange.Discount}}
                            </th>
                        </tr>
                        <tr>
                            <th colspan="5" class="text-right">សរុបចុងក្រោយ:</th>
                            <th class="text-right">
                                {{exchange.PaidAmount}}
                            </th>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "PurchasesExchange",
        data() {
            return {
                company: '',
                employee: {
                    KhmerName: ''
                },
                exchange: {
                    IsApproved: false
                },
                dateExchange: '',
                lines: []
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
        },
        methods: {
            getCompany: function () {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(id) {
                var loading = this.$loading.show();
                this.$api().post('po/exchange/find', {Id: id}).then(res => {
                    if (this.$isValid(res)) {
                        let data = res.data.Json;
                        this.exchange = data.Header;
                        this.dateExchange = data.Header.Date;
                        this.lines = data.Lines;
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        }
    }
</script>
